import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

/**
 * Public "Thank you" page — Square redirects the buyer here after a
 * successful invoice payment. No auth, no API call needed: this is purely
 * a confirmation surface. The branding mirrors the app footer.
 */
export default function PaymentSuccess() {
  return (
    <div
      data-testid="payment-success-page"
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-slate-100 px-6"
    >
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center border border-emerald-200">
        <div className="flex justify-center mb-4">
          <CheckCircle2 className="w-16 h-16 text-emerald-500" strokeWidth={1.5} />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2" data-testid="payment-success-title">
          Payment Received
        </h1>
        <p className="text-slate-600 mb-6">
          Thank you for your business. Your invoice has been paid successfully
          and a receipt has been emailed to you by Square.
        </p>
        <p className="text-sm text-slate-500 mb-6">
          If you have any questions about this transaction, please reply to the
          original invoice email and we will help right away.
        </p>
        <Link
          to="/"
          data-testid="payment-success-home-link"
          className="inline-block px-5 py-2 rounded-lg bg-slate-900 text-white text-sm font-medium hover:bg-slate-800 transition-colors"
        >
          Return to homepage
        </Link>
      </div>
    </div>
  );
}
